<script lang="ts">
	import { assets } from "$app/paths";
	import type { ArtistInfo } from "../../../@types/artist-data";
    import Image from '$lib/components/Image.svelte';
	import { getLang } from "$lib/translations/translations";
	import { page } from "$app/stores";

    export let artistInfo: ArtistInfo;
	$: socials = Object.entries(artistInfo.social).map(([name, value]) => {
		const link = value.link;
		let icon: string;
		if (name === 'sns')
			icon = 'twitter';
		else if (name === 'illust')
			icon = 'pixiv';
		else if (name === 'patreon')
			icon = 'patreon';
		else if (name === 'circle')
			icon = 'home';
		else if (name === 'store') {
			if (link.match(/booth/))
				icon = 'booth';
			else
				icon = 'dlsite';
		} else if (name === 'video')
			icon = 'youtube';
		else
			icon = 'blank';
		return { name, icon, link }
	}).filter(social => social.link !== '');

	let lang: 'ja' | 'zh_cn' | 'zh_tw';
	$: lang = (getLang($page.url).value?.replace('-', '_') || 'ja') as 'ja' | 'zh_cn' | 'zh_tw';
</script>

<h1 class="name name-jp-default font-base-jp">{artistInfo.name[lang]}</h1>
<p class="name-eng name-en-default font-base-jp">{artistInfo.name.en}</p>
<div class="social">
	{#each socials as social}
		<a href={social.link} target="_blank">
			<img src="{assets}/img/services/profile/{social.icon}.svg" alt={social.name} />
		</a>
	{/each}
</div>

<style lang="scss">
    .name {
		font-size: 36px;
	}
	.name-eng {
		margin-top: 8px;
	}
	.social {
		display: flex;
		margin: 30px 0 5px;
		gap: 15px;
	}
	img {
		width: 24px;
		height: 24px;
		transition: transform 0.4s ease;
		&:hover {
			transform: translateY(-2px);
		}
	}
</style>
